module.exports = __webpack_public_path__ + "b2cc35cbc87588ed0c79d270a9fd7529.fbx";